import { useScrollAnimation, useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";
import { galleryImages } from "@/mocks/galleryData";

const homeGalleryImages = galleryImages.slice(0, 6);

export default function Gallery() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { setRef, visibleItems } = useScrollAnimationMultiple(homeGalleryImages.length);

  return (
    <section id="gallery" className="bg-[#1B2A4A] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headRef as (el: HTMLDivElement | null) => void}
          className={`text-center mb-12 reveal ${headVisible ? "visible" : ""}`}
        >
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white/10 px-3 py-1.5 rounded-full mb-3">
            Visual Tour
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Projects in Pictures
          </h2>
          <p className="text-white/60 text-sm max-w-md mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Real photographs from Urban Infra&apos;s eco-friendly villa plot communities on Sarjapur Road, Bengaluru.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {homeGalleryImages.map((img, idx) => (
            <div
              key={img.id}
              ref={setRef(idx) as (el: HTMLDivElement | null) => void}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer reveal reveal-delay-${Math.min(idx + 1, 6)} ${visibleItems[idx] ? "visible" : ""} ${idx === 0 || idx === 3 ? "lg:col-span-2" : "lg:col-span-1"}`}
            >
              <div className={`w-full overflow-hidden ${idx === 0 || idx === 3 ? "h-64 md:h-72" : "h-56 md:h-64"}`}>
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-[#1B2A4A]/0 group-hover:bg-[#1B2A4A]/50 transition-all duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center bg-[#7FBF3F] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-75 group-hover:scale-100">
                  <i className="ri-zoom-in-line text-white"></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#1B2A4A]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-sm font-semibold">{img.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="/gallery"
            className="btn-hover inline-flex items-center gap-2 border-2 border-[#7FBF3F] text-[#7FBF3F] font-semibold text-sm px-7 py-3 rounded-full hover:bg-[#7FBF3F] hover:text-white cursor-pointer whitespace-nowrap transition-colors duration-200"
          >
            View Full Gallery
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
